import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ContentContainer, PageStyles } from './NoLimitsChat.styles.ts';

const NoLimitsChatOptions: {
  id: NonNullable<LayoutDataType['no_limits_chat']>;
  title: string;
}[] = [
  {
    id: 'no',
    title: 'No',
  },
  {
    id: 'yes',
    title: 'Yes',
  },
];

export const NoLimitsChat: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'NoLimitsChat',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const noLimitsChat = form.watch('no_limits_chat');

  const handleChange = () => {
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles>
      <IonContent>
        <OnboardingNavigation />
        <ContentContainer>
          <OwnAiTitle className={'title'}>
            Ready to drive the most intense and spicy chats?
          </OwnAiTitle>
          <OnboardingOptionsList direction={'row'}>
            {NoLimitsChatOptions.map((option) => (
              <OnboardingOptionItem
                checked={noLimitsChat === option.id}
                control={form.control}
                option={option}
                name="no_limits_chat"
                key={option.id}
                onChange={() => handleChange()}
                TEST_ID={`no_limits_chat-${option.id}`}
                expand={true}
              />
            ))}
          </OnboardingOptionsList>
        </ContentContainer>
      </IonContent>
    </PageStyles>
  );
};
